import * as React from 'react';
export class NavigationRegion extends React.Component {
  render() {
    const classes = ['navigation-region', this.props.className].filter(val => val).join(' ');
    return React.createElement("section", {
      className: classes
    }, this.props.children);
  }
}